import React from "react";

const Authapi = React.createContext({
    auth: false,
    role: 0,
    authControl: () => {}
});

export default Authapi;